import { HtmlPreviewSheet } from '@trellis/roots/overlays'

import { useInvoicePreviewQuery } from '@/hooks'

export function InvoicePreviewSheet({
  invoiceId,
  onOpenChange,
}: {
  invoiceId: string | null
  onOpenChange: (isOpen: boolean) => void
}) {
  const { data: previewResult } = useInvoicePreviewQuery(invoiceId)

  return (
    <HtmlPreviewSheet
      open={invoiceId !== null}
      onOpenChange={onOpenChange}
      title="Invoice preview"
      description="Preview of the invoice as a PDF."
      html={previewResult?.data}
    />
  )
}
